const primaryNavigation = () => {
  const HIDDEN_BLOCK = ".hidden-empty-block";
  const FIRST_LEVEL = HIDDEN_BLOCK + ".first-level";
  const SECOND_LEVEL = HIDDEN_BLOCK + ".second-level";
  const PRIMARY_UL = "ul.primary";
  const LI_HAS_CHILDREN = "li.nav-item.has-children";
  const DESKTOP_MODAL_ID = "#hoasPrimaryNavigationModal";
  const MOBILE_MODAL_ID = "#hoasMobileModal";

  const ZERO_VALUE = "0px";

  const FIRST_LEVEL_WIDTH = "360px";
  const SECOND_LEVEL_WIDTH = "260px";

  // Helper function to toggle classes on an element
  const toggleClass = (el, className) => el.classList.toggle(className);
  // Helper function to remove class on an element
  const removeClass = (el, className) => el.classList.remove(className);

  const isMobile = () => {
    const bodyClasses = document.body.classList;

    if (bodyClasses.contains("menu-open")) {
      // Mobile menu is opened
      return true;
    }
    return false;
  };

  const getTransform = () => {
    return isMobile() ? "translateY" : "translateX";
  };

  const fadeInUl = (listItem) => {
    const openUl = getUl(listItem);

    if (!openUl) {
      console.warn("Missing UL in fadeInUl");
      return;
    }

    const transform = getTransform();

    openUl.style.display = "flex";
    openUl.style.opacity = "0";
    openUl.style.transform = transform + "(-4px)";
    openUl.style.transition = "opacity 400ms ease, transform 400ms ease";

    requestAnimationFrame(() => {
      openUl.style.opacity = "1";
      openUl.style.transform = transform + "(0)";
    });
  };

  const fadeOutUl = (listItem) => {
    const openUl = getUl(listItem);

    if (!openUl) {
      console.warn("Missing UL in fadeOutUl");
      return;
    }
    openUl.style.display = "none";
  };

  /**
   *
   * Close List-item open states
   * @param {HTMLElement[]} excludes
   * @returns {void}
   */
  const closeListItems = (excludes = []) => {
    const targetClasses = isMobile()
      ? [MOBILE_MODAL_ID, PRIMARY_UL, LI_HAS_CHILDREN].join(" ")
      : [DESKTOP_MODAL_ID, PRIMARY_UL, LI_HAS_CHILDREN].join(" ");

    const allItems = document.querySelectorAll(targetClasses);

    if (allItems?.length <= 0) {
      return;
    }

    allItems.forEach((item) => {
      if (excludes.includes(item)) {
        return;
      }
      item.classList.remove("open");
      fadeOutUl(item);
    });
  };

  /**
   * Get first-level list item based on current list item parentId
   * @param {*} listItem
   * @returns
   */
  const getParentListItem = (listItem) => {
    if (!listItem) {
      return null;
    }

    const parentId = listItem.getAttribute("data-parent-id");

    if (parentId && typeof parseInt(parentId) === "number") {
      const targetModal = isMobile() ? MOBILE_MODAL_ID : DESKTOP_MODAL_ID;

      const targetClasses = [targetModal, PRIMARY_UL, "> li"].join(" ");

      const primaryListItems = document.querySelectorAll(targetClasses);
      return primaryListItems[parentId] ?? null;
    }

    return null;
  };

  const setEmptyBlockWidth = (targetClass) => {
    if (isMobile()) {
      return;
    }

    const width =
      targetClass === FIRST_LEVEL ? FIRST_LEVEL_WIDTH : SECOND_LEVEL_WIDTH;

    const hiddenBlock = document.querySelector(
      [DESKTOP_MODAL_ID, targetClass].join(" "),
    );

    if (!hiddenBlock) {
      console.warn("Missing hiddenBlock");
      return;
    }

    if (hiddenBlock.style.width === width) {
      return;
    }

    if (!hiddenBlock.style.width) {
      hiddenBlock.style.width = ZERO_VALUE;
    }

    hiddenBlock.getBoundingClientRect();

    requestAnimationFrame(() => {
      hiddenBlock.style.width = width;
    });
  };

  const closeSecondLevelBlock = () => {
    const block = document.querySelector(
      [DESKTOP_MODAL_ID, SECOND_LEVEL].join(" "),
    );
    block.style.width = ZERO_VALUE;
  };

  const resetEmptyBlocks = () => {
    if (isMobile()) {
      return;
    }

    closeSecondLevelBlock();

    const firstBlock = document.querySelector(
      [DESKTOP_MODAL_ID, FIRST_LEVEL].join(" "),
    );
    if (firstBlock) {
      firstBlock.style.width = ZERO_VALUE;
    }
  };

  /**
   *
   * @param {HTMLElement} listItem
   * @returns {HTMLUListElement|undefined|null}
   */
  const getUl = (listItem) => {
    const openUL = listItem.querySelector("ul");

    if (!openUL) {
      return;
    }

    return openUL;
  };

  /**
   * Move position to left
   * @param {HTMLUListElement} listItem
   * @returns {void}
   */
  const moveUl = (listItem) => {
    if (isMobile()) {
      return;
    }
    const openUl = getUl(listItem);

    if (!openUl) {
      console.warn("Missing UL in moveUl");
      return;
    }

    const staticElements = listItem.querySelectorAll(
      ":scope > a, :scope > button",
    );

    const itemWidth = Array.from(staticElements).reduce(
      (total, el) => total + el.getBoundingClientRect().width,
      0,
    );

    const widthWithMargin = itemWidth + 48;
    openUl.style.left = widthWithMargin + "px";
  };

  const focusToActiveElement = (listItem) => {
    if (!listItem) {
      console.warn("Missing list-item. Can not focus nor scroll");
    }

    listItem.focus();
    listItem.scrollIntoView({ behavior: "smooth", block: "center" });
  };

  const secondLevel = (listItem) => {
    const parentItem = getParentListItem(listItem);
    const openUL = getUl(listItem);

    if (!parentItem || !openUL) {
      console.warn("Error in primary-navigation second-level");
      return;
    }

    fadeInUl(listItem);
    setEmptyBlockWidth(SECOND_LEVEL);
    moveUl(listItem);
    closeListItems([listItem, parentItem]);
    focusToActiveElement(listItem);
  };

  const firstLevel = (listItem) => {
    const openUL = getUl(listItem);
    if (!openUL) {
      console.warn("Error in primary-navigation first-level");
      return;
    }

    fadeInUl(listItem);
    setEmptyBlockWidth(FIRST_LEVEL);
    moveUl(listItem);
    closeListItems([listItem]);
    closeSecondLevelBlock();
    focusToActiveElement(listItem);
  };

  const handleOpen = (listItem) => {
    const parentId = listItem.getAttribute("data-parent-id");
    if (!parentId) {
      return firstLevel(listItem);
    }

    return secondLevel(listItem);
  };

  const handleClose = (listItem) => {
    if (!listItem) {
      return;
    }

    const parentLi = getParentListItem(listItem);

    if (!parentLi) {
      closeListItems();
      resetEmptyBlocks();
      return;
    }

    closeListItems([parentLi]);
    closeSecondLevelBlock();
  };

  const handlePrimaryNavigation = (event) => {
    if (event.type !== "click" && event.keyCode !== 13) {
      return;
    }

    const target = event.target;

    if (target?.classList?.contains("nav-link")) {
      return event;
    }

    // Clicked the button in open position!
    const listItem = event.target.closest("li.has-children");

    if (!listItem) {
      return;
    }

    const opened = listItem.classList.contains("open");
    opened ? listItem.classList.remove("open") : listItem.classList.add("open");

    if (!opened) {
      return handleOpen(listItem);
    }

    return handleClose(listItem);
  };

  /**
   * Handle navigation menu actions
   * @returns {void}
   */
  const navigationMenuActions = () => {
    const submenuToggle = document.querySelectorAll(".submenu-toggle");

    const countWidth = (listDom) => {
      const link = listDom.querySelector("a");
      const button = listDom.querySelector("button");
      return link?.offsetWidth + button?.offsetWidth ?? null;
    };

    const toggleSubMenu = function (e) {
      if (
        e.keyCode == 0 ||
        e.keyCode == 13 ||
        e.keyCode === 40 ||
        e.type === "click"
      ) {
        e.preventDefault();

        const clickedItem = e.currentTarget;
        const currentItemParent = clickedItem.parentNode;

        if (currentItemParent.classList.contains("sub-menu-open")) {
          // Mark the parent element as collapsed
          currentItemParent.setAttribute("aria-expanded", "false");
          // Mark the button for the screen reader
          clickedItem.setAttribute("aria-expanded", "false");
          toggleClass(currentItemParent, "sub-menu-open");
          return;
        }

        // Mark the parent element as expanded
        currentItemParent.setAttribute("aria-expanded", "true");
        // Mark the button for the screen reader
        clickedItem.setAttribute("aria-expanded", "true");

        currentItemParent.style.setProperty(
          "--underline-width",
          countWidth(currentItemParent) + "px",
        );

        toggleClass(currentItemParent, "sub-menu-open");
      }
    };

    submenuToggle.forEach(function (element) {
      element.addEventListener("click", toggleSubMenu);
      element.addEventListener("keydown", toggleSubMenu);
    });

    // Add listener for closing the menu, when clicked outside
    document.addEventListener("click", (evt) => {
      const primaryNav = document.querySelector("nav.navbar-primary");
      let targetElement = evt.target;

      do {
        if (targetElement == primaryNav) {
          // This is a click inside. Do nothing, just return.
          return;
        }
        // Go up the DOM
        targetElement = targetElement.parentNode;
      } while (targetElement);

      // This is a click outside.
      let openMenus = document.querySelectorAll(".sub-menu-open");

      openMenus.forEach(function (element) {
        element.setAttribute("aria-expanded", "false");
        removeClass(element, "sub-menu-open");
      });
    });
  };

  return {
    handlePrimaryNavigation: handlePrimaryNavigation,
    navigationMenuActions: navigationMenuActions,
  };
};

export default primaryNavigation;
